import ReactOnRails from "react-on-rails/client";
import {
  ReferralPage,
  USQCPPage,
  UKQCPPage,
  AgentReferralPage,
  QuestionnairePage,
  PersonalisedCoverPage,
  UnderwriterLegalAgreementsPage,
  ShowcasePage,
  PostQuoteQuestionnairePage,
  RecommendationsPage,
} from "@simplybusiness/mobius-journey";
import DevTools from "./components/DevTools";
import Autofill from "./components/Autofill";
import SkipToQcp from "./components/SkipToQcp";
import ViewTraces from "./components/ViewTraces";

ReactOnRails.register({
  ReferralPage,
  USQCPPage,
  UKQCPPage,
  AgentReferralPage,
  QuestionnairePage,
  PersonalisedCoverPage,
  UnderwriterLegalAgreementsPage,
  PostQuoteQuestionnairePage,
  ShowcasePage,
  RecommendationsPage,
  DevTools,
  Autofill,
  SkipToQcp,
  ViewTraces,
});
